import { render } from "./ClientMessages.vue?vue&type=template&id=25526c46"
import script from "./ClientMessages.vue?vue&type=script&lang=js"
export * from "./ClientMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__